import { takeEvery, put, call, fork, delay } from 'redux-saga/effects';
import { Client } from '../../utils/client';
import { SEARCH_OVERSEAS_ON_LOAD, searchOverseasOnLoadSuccess, SEARCH_OVERSEAS_FILTER, searchOverseasFilterSuccess, SEARCH_OVERSEAS_DETAILS, searchOverseasDetailsSuccess } from './actions';
import { appLogout } from '../../redux-root/actions';

export function* searchOverseasOnLoad(action) {
  try {
    // const data = yield call(Client.getData, '/api/v1/remittances/transactions/status');

    // console.log(data);

    const data = [ // SAMPLE
      "PAYMENT_VALIDATED_FAILED",
      "PAYMENT_VALIDATED",
      "PAYMENT_ACCEPTED",
      "PAYMENT_AML_FAIL",
      "PAYMENT_RESERVED_FAILED",
      "PAYMENT_TIMEOUT",
      "PAYMENT_RESERVED",
      "PAYMENT_REFUND_REQUIRED",
      "PAYMENT_ERROR",
      "TRANSACTION_TIMEOUT",
      "TRANSACTION_COMPLETED",
      "TRANSACTION_SUCCESS",
      "TRANSACTION_CONFIRMED",
      "TRANSACTION_SENDSMS_FAILED",
      "TRANSACTION_ON_HOLD",
      "TRANSACTION_FAIL",
      "TRANSACTION_SUBMITTED",
      "TRANSACTION_AVAILABLE",
      "TRANSACTION_IN_PROGRESS",
      "TRANSACTION_DECLINED",
      "TRANSACTION_REVERSED",
      "TRANSACTION_CANCELLED",
      "TRANSACTION_REJECTED",
      "REFUNDED",
      "REFUND_FAILED"
    ];

    yield put(searchOverseasOnLoadSuccess(data));
  } catch (error) {
    console.log(error);

    if (error.status === 401) {
      yield put(appLogout(true));
    }
  }
}

export function* searchOverseasFilter(action) {
  const paramObject = Object.assign({}, action.payload);

  let params = '';

  if (paramObject.transactionId) {
    params = `transactionId=${paramObject.transactionId}`;
  } else {
    Object.keys(paramObject).forEach(key => {
      if (params) {
        params += `&${key}=${paramObject[key]}`;
      } else {
        params += `${key}=${paramObject[key]}`;
      }
    });
  }

  // console.log(params);

  try {
    // const data = yield call(Client.getData, `/api/v1/remittances/list?${params}&pageSize=100`);

    // console.log(data);

    let sampleDataList = [];

    for (var i = 1; i <= 100; i++) {
      sampleDataList.push({
        hubId: 1,
        hubName: "TELEPIN",
        internalTransactionId: 179,
        recipientCountry: "PHILIPPINES",
        recipientMsisdn: "6381111111114",
        senderMsisdn: null,
        serviceId: 319,
        serviceName: "TransferTo Philippine Mobile",
        status: "TRANSACTION_FAIL",
        transactionDateTime: "2022-06-23T12:37:25.10824",
        transactionId: null
      });
    }

    const data = {
      pageNo: 0,
      pageSize: 25,
      transactionResponseList: sampleDataList
    }

    yield delay(1000);

    yield put(searchOverseasFilterSuccess(data));
  } catch (error) {
    console.log(error);

    if (error.status === 401) {
      yield put(appLogout(true));
    }
  }
}

export function* searchOverseasDetails(action) {
  const id = action.payload;

  try {
    // const data = yield call(Client.getData, `/api/v1/remittances/details/${id}`);

    // console.log(data);

    const data = {
      errorCode: null,
      errorMessage: null,
      forexMarginAmount: null,
      hubSo: "21292472",
      internalTransactionId: 238,
      mlSo: "238",
      recipientCurrency: "INR",
      recipientFullname: null,
      recipientMsisdn: "919935293481",
      remittanceAmtAfterMargin: null,
      remittanceAmtInRecipientCurrency: null,
      remittanceAmtInSenderCurrency: 2,
      retailForexRate: null,
      senderCurrency: "SGD",
      senderFullname: null,
      senderMsisdn: "6584304530",
      senderTelepinId: "913803",
      serviceName: "Tranglo India Mobile",
      status: "TRANSACTION_SUCCESS",
      telepinDomesticSo: "15851748",
      transactionDateTime: "2022-06-28T07:18:55.875943",
      transactionId: "15851748",
      txnAmountWithFee: null,
      txnFee: null,
      txnStatusChange: {
        PAYMENT_VALIDATED: "2022-07-05T11:05:56.613385",
        TRANSACTION_COMPLETED: "2022-07-05T13:16:18.23971",
        TRANSACTION_IN_PROGRESS: "2022-07-05T11:06:01.969249",
        TRANSACTION_SUBMITTED: "2022-07-05T11:06:00.249453"
      }
    };

    yield put(searchOverseasDetailsSuccess(data));
  } catch (error) {
    console.log(error);

    if (error.status === 401) {
      yield put(appLogout(true));
    }
  }
}

function* watchSearchOverseasOnLoad() {
  yield takeEvery(SEARCH_OVERSEAS_ON_LOAD, searchOverseasOnLoad);
}

function* watchSearchOverseasFilter() {
  yield takeEvery(SEARCH_OVERSEAS_FILTER, searchOverseasFilter);
}

function* watchSearchOverseasDetails() {
  yield takeEvery(SEARCH_OVERSEAS_DETAILS, searchOverseasDetails);
}

export function* searchOverseasSaga() {
  yield fork(watchSearchOverseasOnLoad);
  yield fork(watchSearchOverseasFilter);
  yield fork(watchSearchOverseasDetails);
}
